import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

import { LightgalleryProvider, LightgalleryItem } from 'react-lightgallery'

import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { FreeMode, Navigation, Thumbs } from 'swiper'

SwiperCore.use([FreeMode, Navigation, Thumbs])

interface IProps {
  postImages: any[]
}

export const PostGallery: React.FC<IProps> = props => {
  return (
    <PostGalleryWrapper>
      <div className="PostGallery_Main">
        <LightgalleryProvider
          plugins={['lg-fullscreen.js', 'lg-zoom.js']}
          lightgallerySettings={{
            zoom: false,
            fullScreen: false,
            download: false,
          }}
        >
          <Swiper
            navigation={{
              nextEl: '.button-next',
              prevEl: '.button-prev',
              disabledClass: 'button-disabled',
            }}
            slidesPerView={'auto'}
            slidesPerGroup={1}
            spaceBetween={4}
            className="mainSwiper"
            breakpoints={{
              600: {
                spaceBetween: 8,
              },
            }}
          >
            {props.postImages.map((image, index) => (
              <SwiperSlide key={image.id}>
                <LightgalleryItem group="header" src={image.large_url} subHtml={image.description}>
                  <img
                    src={image.large_url}
                    alt={image.description}
                    loading={index < 2 ? 'eager' : 'lazy'}
                    {...(index === 0 ? ({ fetchpriority: 'high' } as any) : {})}
                  />
                </LightgalleryItem>
              </SwiperSlide>
            ))}
            <button type="button" className="button-prev" aria-label="Prev Image">
              <SvgIcon
                name="keyboard_arrow_left"
                className="icon"
                ariaHidden={true}
                role="presentation"
              />
            </button>
            <button type="button" className="button-next" aria-label="Next Image">
              <SvgIcon
                name="keyboard_arrow_right"
                className="icon"
                ariaHidden={true}
                role="presentation"
              />
            </button>
          </Swiper>
        </LightgalleryProvider>
      </div>
    </PostGalleryWrapper>
  )
}

const PostGalleryWrapper = styled.div`
  margin: 0 0 4rem;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    margin: 0 0 2.4rem;
  }
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    margin: 0;
  }
  .navSwiper {
    margin-top: 1.6rem;
    img {
      border: 1px solid ${constants.COLORS.divider};
    }
    .swiper-slide-thumb-active {
      img {
        border-color: ${constants.COLORS.primary};
      }
    }
  }
  .swiper-slide {
    width: auto;
    img {
      width: auto;
      height: 40rem;
      vertical-align: bottom;
      @media (max-width: ${constants.BREAKPOINT_DESKTOP_XL}px) {
        height: 32rem;
      }
      @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
        height: 25rem;
      }
    }
  }

  .ImageDescription {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 4px 8px;
    color: white;
    font-size: 14px;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 0 0 10px 10px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      border-radius: 0;
    }
  }

  .button-prev,
  .button-next {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    width: 4rem;
    height: 4rem;
    padding: 0;
    background-color: rgba(0, 0, 0, 0.5);
    border: 0;
    border-radius: 50%;
    transform: translateY(-50%);
    transition: background-color 0.2s;
    z-index: 1000;
    cursor: pointer;
    .icon {
      color: ${constants.COLORS.white};
      width: 2.4rem;
      height: 2.4rem;
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.75);
    }
    &.button-disabled {
      background-color: rgba(0, 0, 0, 0.25);
      .icon {
        color: ${constants.COLORS.disabled};
        opacity: 0.5;
        cursor: default;
      }
    }
  }
  .button-prev {
    left: 1.6rem;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      left: 1.2rem;
    }
  }
  .button-next {
    right: 1.6rem;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      right: 1.2rem;
    }
  }
`
